/**
 * Custom: drop the " | " divider from the product page heading entirely,
 * e.g. "Beverly Hills | Topaz Cushion" -> "Beverly Hills Topaz Cushion".
 * Done in JS rather than CSS since this is a change to the literal title
 * text itself, not something CSS alone can do.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__title > h1').forEach(function (heading) {
    heading.textContent = heading.textContent.replace(/\s*\|\s*/g, ' ');
  });
});
